import * as State from 'components/desktop/BaseIngredient/Search/SearchState';
import { useHandler } from 'hooks/useHandler';

export default function useSearchState(initialSearch: State.Type) {
	const [state, rf] = useHandler<State.Type>(initialSearch);
	return {
		state,
		handlers: {
			setSearchTerm: rf.createReducer(State.setSearchTerm),
			toggleShowAdvancedSearch: rf.createNoArgReducer(State.toggleShowAdvancedSearch),
		},
	};
}
